import React, { useState } from 'react';
import { useUnits } from '../../contexts/UnitsContext';
import './AddMeasurementModal.css';

const AddMeasurementModal = ({ availableTypes, close, onAdd }) => {
  const { weightUnit } = useUnits();
  const [selectedTypeId, setSelectedTypeId] = useState('');
  const [value, setValue] = useState('');

  const handleAdd = () => {
    if (!selectedTypeId || value === '') {
      alert('Please select a measurement type and enter a value.');
      return;
    }

    const numericValue = Number(value);
    if (!Number.isFinite(numericValue) || (selectedTypeId === 'weight' && (numericValue <= 0 || !['kg', 'lb', 'lbs'].includes(weightUnit)))) {
      alert('Enter a finite weight greater than zero in kg or lb.');
      return;
    }
    onAdd(selectedTypeId, numericValue, ...(selectedTypeId === 'weight' ? [weightUnit] : []));
    close();
  };

  return (
    <div className="add-measurement-modal">
      <h2>Add Measurement</h2>
      <div className="measurement-selection-container">
        <select
          value={selectedTypeId}
          onChange={(e) => setSelectedTypeId(e.target.value)}
        >
          <option value="">Select Measurement Type</option>
          {availableTypes.map((type) => (
            <option key={type._id} value={type._id}>
              {type.name}
            </option>
          ))}
        </select>
        <input
          type="number"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={`Enter value${selectedTypeId === 'weight' ? ` (${weightUnit})` : ''}`}
        />
      </div>
      <div className="button-container">
        <button className="btn-add" onClick={handleAdd} disabled={!selectedTypeId || value === ''}>
          Add Measurement
        </button>
        <button className="btn-cancel" onClick={close}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default AddMeasurementModal;